import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import bemBlock from '@gik/core/utils/bemBlock';
import FontIcon from '../FontIcon';
import classNames from 'classnames';
import { gikClassPrefix } from '@gik/core/constants';
import useBackButtonOverride from '../BackButtonOverride/useBackButtonOverride';

const blockName = `${gikClassPrefix}-interstitial`;
const bem = bemBlock(blockName, '');

export interface InterstitialProps {
  isOpen: boolean;
  onClose?(): void;
  children?: React.ReactNode;
  contentClassName?: string;
}

export default function Interstitial({
  isOpen,
  onClose,
  children,
  contentClassName,
}: InterstitialProps): React.ReactElement {
  useBackButtonOverride(isOpen, onClose);

  const portalRef = React.useRef<HTMLDivElement>(null);
  useEffect(() => {
    const className = `${blockName}__body-hook`;
    if (isOpen) {
      document.body.classList.add(className);
    } else {
      document.body.classList.remove(className);
    }
  }, [isOpen]);

  const portalContainer = (
    <div ref={portalRef} className={bem('portal', isOpen ? 'open' : '')}>
      <div className={classNames([{ [bem('content')]: true }, { [contentClassName]: contentClassName }])}>
        <div className={bem('close')} onClick={onClose}>
          <FontIcon name="close" size="lg" onClick={onClose} />
        </div>
        {children}
      </div>
    </div>
  );

  return ReactDOM.createPortal(portalContainer, document.body);
}
